<template lang="pug">
#mhome
  mobile-nav
  vheader
  banner
  business
  events
  tutor
  vcontent
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import Banner from '../components/mobile/Banner.vue'
import Business from '../components/Business.vue'
import Events from '../components/Events.vue'
import Tutor from '../components/mobile/Tutor.vue'
import Vcontent from '../components/mobile/Content.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  name: 'app',
  components: {
    Vheader,
    Banner,
    Business,
    Events,
    Tutor,
    Vcontent,
    Vfooter,
    'mobile-nav': MobileNav,
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$route.hash) {
        setTimeout(() => {
          let el = document.querySelector(this.$route.hash)
          if (el) {
            window.scrollTo({top: el.offsetTop - 50, behavior: 'smooth'})
          }
        }, 2000)
      }
    })
  }
}
</script>

<style lang="stylus">

#mhome
  width 100%
  // height 100%
</style>



// WEBPACK FOOTER //
// MHome.vue?5c8749b0